import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main
      data-testid="not-found-page"
      className="min-h-screen bg-white flex items-center justify-center px-6"
    >
      <div className="max-w-xl text-center">
        <div className="text-xs font-semibold uppercase tracking-[0.22em] text-gray-500">
          404 · Off the course
        </div>
        <h1 className="mt-6 font-serif-display text-6xl sm:text-7xl font-light tracking-tight text-black leading-[1.0]">
          Page not found
        </h1>
        <p className="mt-6 text-base text-gray-600 font-light leading-relaxed">
          The page you're looking for has wandered off the track. Let's bring you back to the portfolio.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="mt-10 inline-flex items-center gap-2 bg-black text-white hover:bg-[#1a1a1a] rounded-full px-7 py-3.5 text-sm font-medium transition-colors"
        >
          Return home
        </Link>
      </div>
    </main>
  );
}
